const api = `${process.env.PUBLIC_URL}/api`;
export const ChatMemberApi = `${api}/chatmember.json`;
export const ChatsApi = `${api}/chats.json`;